import { useState } from "react";
import { Vector3 } from 'three';
import Hotspot from './Hotspot';

/**
 * @param {Object} props
 * @param {boolean} [props.loop=false] - Indica si el tour reinicia al cerrar el último modal (lógica en useHotspotTour).
 */
export default function HotspotManager({ 
    hotspots,
    loop = false, // API: el comportamiento loop se controla desde useHotspotTour({ loop })
    currentIndex,
    isModalOpen,
    isWaitingForNext,
    onOpenModal,
    isEditMode = false,
    // onHotspotUpdate
}) {

    const [editPositions, setEditPositions] = useState({});

    // En modo edición, mostrar todos los hotspots
    if (isEditMode) {
        return (
            <>
                {hotspots.map((hotspot) => {
                    // Usar posición del hotspotData o posición editada
                    const defaultPos = hotspot.position 
                        ? new Vector3(hotspot.position.x, hotspot.position.y, hotspot.position.z)
                        : new Vector3(0, 0, 0);
                    
                    const position = editPositions[hotspot.id] || defaultPos; // Desde el origen

                    return (
                        <Hotspot
                            key={hotspot.id}
                            position={position}
                            onClick={onOpenModal}
                            data={hotspot.content}
                            isEditMode={true}
                            hotspotId={hotspot.id}
                            onPositionUpdate={(id, newPos) => {
                                setEditPositions(prev => ({ ...prev, [id]: newPos }));
                                // if (onHotspotUpdate) {
                                //     onHotspotUpdate(id, newPos.x, newPos.y, newPos.z);
                                // }
                            }}
                        />
                    );
                })}
            </>
        );
    }

    // Modo normal
    if (currentIndex >= hotspots.length) {
        return null;
    }

    if (isWaitingForNext || isModalOpen) {
        return null;
    }

    const currentHotspot = hotspots[currentIndex];
    
    // Leer posición directa de hotspotData
    if (!currentHotspot.position) {
        return null;
    }

    const position = new Vector3(
        currentHotspot.position.x,
        currentHotspot.position.y,
        currentHotspot.position.z
    );

    return (
        <Hotspot
            position={position}
            onClick={onOpenModal}
            data={currentHotspot.content}
            isEditMode={false}
        />
    );
}
